/*  This file used to get info from the user to determine screen size, user agent etc */
import { Dimensions } from 'react-native';

const width = Dimensions.get('window').width;
const height = Dimensions.get('window').height;

export default {
  window: {
    width,
    height,
  },
  isSmallDevice: width < 375,
  isXtraSmallDevice: width < 281,
};
